<mat-toolbar color="primary">
  <mat-toolbar-row>
    <a class=" col-1" href="/"><img class="img-fluid" src="../../../../assets/img/logo.png" alt="logo" /></a>
    <span class="spacer"></span>
    <a mat-button routerLink="/register">Register</a>
    <a mat-button routerLink="/login">Login</a>
  </mat-toolbar-row>
</mat-toolbar>
<app-login-molecule></app-login-molecule>